import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlSignature } from '../common/apiEndPoint';

@Injectable({
  providedIn: 'root'
})
export class ResetpasswordemailserviceService {

  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private http: HttpClient,
    private urlSignature: UrlSignature
  ) { }

  /**
   * Send password reset link to user's email
   */
  sendResetLink(email: string): Observable<any> {
    const payload = {
      email: email
    };

    return this.http.post(
      this.urlSignature.sendlinkforforgotpasswordUrl,
      payload,
      { headers: this.headers }
    );
  }


  resetPassword(token: string, newPassword: string): Observable<any> {
    const payload = {
      token: token,
      newPassword: newPassword
    };

    return this.http.post(
      this.urlSignature.resetPasswordUrl,
      payload,
      { headers: this.headers }
    );
  }
}